// ReviewMealsIntro.js — Session-scoped flag helpers for the Review Meals onboarding intro.
// The actual intro UI lives inside MealPlanHeader (morphs from fullscreen intro to compact header).

export const INTRO_DURATION_MS = 6000;
const INTRO_SESSION_KEY = 'reviewMealsIntroShown';

/**
 * Returns true on first visit in the current browser session.
 */
export function shouldShowIntro() {
  if (typeof window === 'undefined') return false;
  try {
    return !sessionStorage.getItem(INTRO_SESSION_KEY);
  } catch {
    return false;
  }
}

export function markIntroShown() {
  try { sessionStorage.setItem(INTRO_SESSION_KEY, '1'); } catch {}
}
